var _rect, _mask, _path, _mask2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _mask3, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTpIconGrowthMinded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F2F2FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_28201_16733",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8445 14.4445C16.7469 16.1654 16.0831 17.8015 14.9617 19.0855C13.8403 20.3695 12.3274 21.2255 10.6703 21.5137C9.01326 21.8019 7.30987 21.5052 5.83843 20.6721C4.367 19.839 3.21451 18.5188 2.56922 16.927C1.92394 15.3353 1.824 13.5662 2.28574 11.9087C2.74749 10.2512 3.74361 8.80329 5.11139 7.80149C6.47917 6.79969 8.13776 6.30322 9.81621 6.3932C11.4947 6.48317 13.0937 7.15426 14.3522 8.29684L9.42848 14.0019L16.8445 14.4445Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8445 14.4445C16.7469 16.1654 16.0831 17.8015 14.9617 19.0855C13.8403 20.3695 12.3274 21.2255 10.6703 21.5137C9.01326 21.8019 7.30987 21.5052 5.83843 20.6721C4.367 19.839 3.21451 18.5188 2.56922 16.927C1.92394 15.3353 1.824 13.5662 2.28574 11.9087C2.74749 10.2512 3.74361 8.80329 5.11139 7.80149C6.47917 6.79969 8.13776 6.30322 9.81621 6.3932C11.4947 6.48317 13.0937 7.15426 14.3522 8.29684L9.42848 14.0019L16.8445 14.4445Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.761905,
    mask: "url(#path-2-inside-1_28201_16733)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_28201_16733",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2095 8.65807C17.177 9.81478 17.7841 11.2425 17.9523 12.7568L10.5714 13.619L16.2095 8.65807Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2095 8.65807C17.177 9.81478 17.7841 11.2425 17.9523 12.7568L10.5714 13.619L16.2095 8.65807Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.761905,
    mask: "url(#path-3-inside-2_28201_16733)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5775 25.7393V33.7607H32.0892V25.7393H35.5775Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.478125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2443 22.3408V33.7627H37.756V22.3408H41.2443Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.478125
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.911 17.2393V33.7607H43.4227V17.2393H46.911Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.478125
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9699 30.5772C30.9699 30.5772 29.5065 31.3226 29.866 32.4821L30.7124 31.796L31.5588 31.1098L30.9699 30.5772Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.404643,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9701 30.5774C30.9701 30.5774 29.5067 31.3228 29.8662 32.4823L31.7757 31.7179L31.5589 31.11L30.9701 30.5774Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.404643,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2848 42.9988L18.4988 42.1895V23.5759C17.9592 24.2503 16.5565 25.4372 15.2616 24.7898C13.643 23.9805 14.0443 21.2376 14.0443 21.2376C14.0443 21.2376 15.936 16.1574 17.2848 14.2691C17.1499 13.5947 16.9611 12.1649 17.2848 11.8412L18.9034 10.2227L19.308 10.6273L18.9034 12.2459C18.7685 12.5156 18.4988 13.1361 18.4988 13.4598C18.4988 13.7835 19.0383 14.1342 19.308 14.2691L20.522 13.4598L20.9266 13.8644L20.3572 14.7898H27.5154C28.6257 14.7898 29.6206 15.4708 29.9953 16.5159C30.8533 18.9094 32.3126 23.2518 32.6613 26.0037C32.9393 28.1985 32.6613 31.6688 32.6613 31.6688L30.6381 32.0734C30.6381 32.0734 30.6547 28.3417 30.2334 26.0037C29.7637 23.3968 28.2102 19.5295 28.2102 19.5295L28.6148 42.1895L29.8288 42.9988H24.5684L24.2533 23.9805H22.91L22.1405 42.9988H17.2848Z",
    fill: "#1C77EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4988 19.9341V23.5759M18.4988 23.5759V42.1895L17.2848 42.9988H22.1405L22.91 23.9805H24.2533L24.5684 42.9988H29.8288L28.6148 42.1895L28.2102 19.5295C28.2102 19.5295 29.7637 23.3968 30.2334 26.0037C30.6547 28.3417 30.6381 32.0734 30.6381 32.0734L32.6613 31.6688C32.6613 31.6688 32.9393 28.1985 32.6613 26.0037C32.3126 23.2518 30.8533 18.9094 29.9953 16.5159C29.6206 15.4708 28.6257 14.7898 27.5154 14.7898H20.3572L17.6895 19.1248L20.9266 13.8644L20.522 13.4598L19.308 14.2691C19.0383 14.1342 18.4988 13.7835 18.4988 13.4598C18.4988 13.1361 18.7685 12.5156 18.9034 12.2459L19.308 10.6273L18.9034 10.2227C18.4988 10.6273 17.6085 11.5175 17.2848 11.8412C16.9611 12.1649 17.1499 13.5947 17.2848 14.2691C15.936 16.1574 14.0443 21.2376 14.0443 21.2376C14.0443 21.2376 13.643 23.9805 15.2616 24.7898C16.5565 25.4372 17.9592 24.2503 18.4988 23.5759Z",
    stroke: "#2D5AD9",
    strokeWidth: 0.404643,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7652 9.44961L21.2982 9.44961L22.4263 11.4047L18.6116 15.0606L18.0743 15.0222L17.1592 13.0429L20.7652 9.44961Z",
    fill: "#00D2A3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6116 15.0606L18.0743 15.0222L17.1592 13.0429L20.7652 9.44961L21.2982 9.44961L22.4263 11.4047L18.6116 15.0606ZM21.2982 9.44961L17.6656 13.0429M17.1592 13.0429L17.6656 13.0429M17.6656 13.0429L18.6116 15.0606",
    stroke: "#118F72",
    strokeWidth: 0.268657
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5965 31.1797L35.8054 31.7736V37.7123V39.4939L28.0144 43.0006L26.1338 41.8694V34.7429L34.5965 31.1797Z",
    fill: "#00D2A3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0144 43.0006L26.1338 41.8694V34.7429L34.5965 31.1797L35.8054 31.7736V37.7123V39.4939L28.0144 43.0006ZM35.8054 31.7736L27.9472 35.3368M26.1338 34.7429L27.9472 35.3368M27.9472 35.3368L28.0144 43.0006",
    stroke: "#118F72",
    strokeWidth: 0.404643
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3577 36.2825L30.9696 35.4766V38.9691L29.3577 39.7751V36.2825Z",
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.268657
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1189 34.6732L34.7308 33.8672V37.3597L33.1189 38.1657V34.6732Z",
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.268657
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0144 38.7014L29.3577 38.1641",
    stroke: "#118F72",
    strokeWidth: 0.268657
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9696 37.3598L33.1189 36.2852",
    stroke: "#118F72",
    strokeWidth: 0.268657
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7308 35.4787L35.8055 34.9414",
    stroke: "#118F72",
    strokeWidth: 0.268657
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-3_28201_16733",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5862 32.209L30.2327 32.8857V34.0986L29.4241 33.6943V32.4805L30.7766 31.8047L31.5862 32.209ZM33.47 31.6699V32.8838L32.6614 32.4795V31.2656L33.47 31.6699Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5862 32.209L30.2327 32.8857V34.0986L29.4241 33.6943V32.4805L30.7766 31.8047L31.5862 32.209ZM33.47 31.6699V32.8838L32.6614 32.4795V31.2656L33.47 31.6699Z",
    fill: "#00D2A3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5862 32.209L31.7671 32.5709L32.4914 32.2088L31.767 31.847L31.5862 32.209ZM30.2327 32.8857L30.0517 32.5238L29.828 32.6357V32.8857H30.2327ZM30.2327 34.0986L30.0517 34.4606L30.6373 34.7534V34.0986H30.2327ZM29.4241 33.6943H29.0194V33.9444L29.2431 34.0563L29.4241 33.6943ZM29.4241 32.4805L29.2432 32.1185L29.0194 32.2303V32.4805H29.4241ZM30.7766 31.8047L30.9574 31.4427L30.7766 31.3524L30.5958 31.4427L30.7766 31.8047ZM33.47 31.6699H33.8746V31.4198L33.6509 31.308L33.47 31.6699ZM33.47 32.8838L33.289 33.2457L33.8746 33.5385V32.8838H33.47ZM32.6614 32.4795H32.2567V32.7296L32.4804 32.8414L32.6614 32.4795ZM32.6614 31.2656L32.8423 30.9037L32.2567 30.6109V31.2656H32.6614ZM31.5862 32.209L31.4052 31.8471L30.0517 32.5238L30.2327 32.8857L30.4136 33.2477L31.7671 32.5709L31.5862 32.209ZM30.2327 32.8857H29.828V34.0986H30.2327H30.6373V32.8857H30.2327ZM30.2327 34.0986L30.4136 33.7367L29.605 33.3324L29.4241 33.6943L29.2431 34.0563L30.0517 34.4606L30.2327 34.0986ZM29.4241 33.6943H29.8287V32.4805H29.4241H29.0194V33.6943H29.4241ZM29.4241 32.4805L29.6049 32.8424L30.9575 32.1667L30.7766 31.8047L30.5958 31.4427L29.2432 32.1185L29.4241 32.4805ZM30.7766 31.8047L30.5958 32.1667L31.4054 32.571L31.5862 32.209L31.767 31.847L30.9574 31.4427L30.7766 31.8047ZM33.47 31.6699H33.0653V32.8838H33.47H33.8746V31.6699H33.47ZM33.47 32.8838L33.6509 32.5219L32.8423 32.1176L32.6614 32.4795L32.4804 32.8414L33.289 33.2457L33.47 32.8838ZM32.6614 32.4795H33.066V31.2656H32.6614H32.2567V32.4795H32.6614ZM32.6614 31.2656L32.4804 31.6275L33.289 32.0318L33.47 31.6699L33.6509 31.308L32.8423 30.9037L32.6614 31.2656Z",
    fill: "#118F72",
    mask: "url(#path-20-inside-3_28201_16733)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5436 9.30469H21.4899C21.0872 9.30469 20.7607 9.63117 20.7607 10.0339C20.7607 10.4366 21.0872 10.7631 21.4899 10.7631H21.5436C21.9463 10.7631 22.2728 10.4366 22.2728 10.0339C22.2728 9.63117 21.9463 9.30469 21.5436 9.30469Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.268657,
    strokeLinecap: "square"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9358 11.7351C26.0675 10.6968 26.0673 9.78644 25.9325 8.7215C25.8047 7.71165 24.9053 7 23.8873 7H23.6922C22.5877 7 21.652 7.83689 21.5771 8.93881C21.511 9.9104 21.495 10.7423 21.5468 11.6102C21.6102 12.6713 22.5323 13.4478 23.5953 13.4478H23.8954C24.9097 13.4478 25.8082 12.7413 25.9358 11.7351Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.268657,
    strokeLinecap: "square"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3794 9.14844H26.3258C25.923 9.14844 25.5965 9.47492 25.5965 9.87765C25.5965 10.2804 25.923 10.6069 26.3258 10.6069H26.3794C26.7822 10.6069 27.1086 10.2804 27.1086 9.87765C27.1086 9.47492 26.7822 9.14844 26.3794 9.14844Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.268657,
    strokeLinecap: "square"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7011 31.717C31.5071 31.717 32.4792 31.1797 32.4792 31.1797V32.6125L31.3789 33.0962C31.0298 33.2496 30.6381 32.9939 30.6381 32.6125L30.7011 31.717Z",
    fill: "#1C77EB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6891 31.4478L32.669 32.2889C32.6643 32.4878 32.5501 32.6677 32.3722 32.7567L31.8862 32.9997C31.8634 33.011 31.8399 33.0208 31.8158 33.0288L31.3452 33.1857C30.9973 33.3016 30.638 33.0427 30.638 32.6759L30.638 31.8028",
    stroke: "#2D5AD9",
    strokeWidth: 0.404643,
    strokeLinecap: "square"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTpIconGrowthMinded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tp_icon_growth_minded.65cfdb60e8239192c2b782e3cdcb5c11.svg";